import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9555cbcc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entry_base_contents_wrapper" }
const _hoisted_2 = { class: "entry_base_indicator_wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "entry_base_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "entry_base_title_text" }, "メールアドレスと携帯電話番号、"),
  /*#__PURE__*/_createElementVNode("span", { class: "entry_base_title_text" }, "パスワードを入力してください")
], -1))
const _hoisted_4 = { class: "entry_base_input" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "メールアドレス"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_6 = { class: "entry_base_input_mail" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "entry_base_input_account_annotation" }, "勤務先メールアドレスのご登録はお控えください", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "entry_base_input_account_annotation" }, " 求人案内などの連絡先として使用します。常時確認できるメールアドレスをご登録ください ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "entry_base_input_account_annotation" }, " メール受信制限をされている方は「@massmedian.co.jp」からのメール受信を許可してください ", -1))
const _hoisted_10 = { class: "entry_base_input" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "携帯電話番号")
], -1))
const _hoisted_12 = { class: "entry_base_input_telCellular" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "entry_base_input_account_annotation" }, " 半角数字のみ、ハイフンなしでご入力ください ", -1))
const _hoisted_14 = { class: "entry_base_input" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "パスワード"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_16 = { class: "entry_base_input_password" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "entry_base_input_account_annotation" }, " パスワードは半角英数字6文字以上12文字以内のアルファベットと数字を各1文字以上を使用してください ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "entry_base_account_provision" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "text_link_outbound entry_base_account_provision_link",
    href: "https://www.massmedian.co.jp/privacy/provision.html",
    target: "_blank"
  }, " 利用規約 "),
  /*#__PURE__*/_createTextVNode(" と "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "text_link_outbound entry_base_account_provision_link",
    href: "https://www.massmedian.co.jp/privacy/",
    target: "_blank"
  }, " 個人情報の取り扱い "),
  /*#__PURE__*/_createTextVNode(" に関して ")
], -1))
const _hoisted_19 = { class: "entry_base_button" }
const _hoisted_20 = { class: "entry_base_button_prev" }
const _hoisted_21 = { class: "entry_base_button_next" }

import { onBeforeMount, ref } from 'vue';
import { useRouter } from 'vue-router';
import store from '@/store';
import { useField, useForm } from 'vee-validate';
import axios from 'axios';
import alertOnReload from '@/utils/alertOnReload';

import BaseButton from '@/components/BaseButton.vue';

import BaseTextForm from '@/components/BaseTextForm.vue';
import BasePasswordForm from '@/components/BasePasswordForm.vue';
import Indicator from '@/components/Indicator.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import { validationRuleHelper } from '@/utils/validationRule';


export default /*#__PURE__*/_defineComponent({
  __name: 'RegistaccountView',
  setup(__props) {

const { meta, errors } = useForm();
const {
  value: mailAddress,
  errors: mailAddressErrors,
  meta: mailAddressMeta,
} = useField<string>('mailAddress', validationRuleHelper({ required: true, email: true }), {
  initialValue: store.getters['userRegistration/mailAddress'],
  bails: false,
  label: 'メールアドレス',
});
const {
  value: password,
  errors: passwordErrors,
  meta: passwordMeta,
} = useField<string>('password', validationRuleHelper({ required: true, min: 6, max: 12, password: true }), {
  initialValue: store.getters['userRegistration/password'],
  bails: false,
  label: 'パスワード',
});
const {
  value: telCellular,
  errors: telCellularErrors,
  meta: telCellularMeta,
} = useField<string>('telCellular', validationRuleHelper({ required: false, telCellular_length: true }), {
  initialValue: store.getters['userRegistration/telCellular'],
  bails: false,
  label: '携帯電話番号',
});
const router = useRouter();


const submit = async () => {

  store.commit('userRegistration/setMailAddress', mailAddress.value);
  store.commit('userRegistration/setPassword', password.value);
  store.commit('userRegistration/setTelCellular', telCellular.value);

  try {
    await store.dispatch('userRegistration/checkRegistAccount');
    router.push({ name: 'b10'});

  } catch (error) {
    console.error(error);

    if (axios.isAxiosError(error) && error.response?.data.errorDetail.fieldError) {
      console.error(error.response.data.errorDetail.fieldError);
    }
    if (axios.isAxiosError(error) && error.response?.data.errorDetail.globalError) {
      console.error(error.response.data.errorDetail.globalError[0].code);
      const errorCode = error.response.data.errorDetail.globalError[0].code;
      router.push({ name: 'b09', query: { code: errorCode } });
    }

    throw error;
  }
};
const transitionPreviousPage = () => {
  router.push({ name: 'b05' });
};

onBeforeMount(async () => {
  const token = store.getters['userRegistration/token'] as string;
  if (!token) {
    router.push({ name: 'b11' });
    return;
  }
});
alertOnReload();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Indicator, {
          current: 8,
          max: 8
        })
      ]),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(BaseTextForm, {
            modelValue: _unref(mailAddress),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(mailAddress) ? (mailAddress).value = $event : null)),
            placeholder: "aaa@massmedian.com",
            type: "email",
            autocomplete: "username",
            isError: _unref(mailAddressMeta).touched && !!_unref(errors).mailAddress,
            onFocusout: _cache[1] || (_cache[1] = () => (_unref(mailAddressMeta).touched = true))
          }, null, 8, ["modelValue", "isError"]),
          (_unref(mailAddressMeta).touched && _unref(errors).mailAddress)
            ? (_openBlock(), _createBlock(ErrorMessage, {
                key: 0,
                errors: _unref(mailAddressErrors)
              }, null, 8, ["errors"]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_7,
        _hoisted_8,
        _hoisted_9
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createVNode(BaseTextForm, {
            placeholder: "09012345678",
            modelValue: _unref(telCellular),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(telCellular) ? (telCellular).value = $event : null)),
            type: "tel",
            autocomplete: "tel",
            isError: _unref(telCellularMeta).touched && !!_unref(errors).telCellular,
            onFocusout: _cache[3] || (_cache[3] = () => (_unref(telCellularMeta).touched = true))
          }, null, 8, ["modelValue", "isError"]),
          (_unref(telCellularMeta).touched && _unref(errors).telCellular)
            ? (_openBlock(), _createBlock(ErrorMessage, {
                key: 0,
                errors: _unref(telCellularErrors)
              }, null, 8, ["errors"]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_13
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _createVNode(BasePasswordForm, {
            placeholder: "パスワード",
            modelValue: _unref(password),
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(password) ? (password).value = $event : null)),
            autocomplete: "new-password",
            isError: _unref(passwordMeta).touched && !!_unref(errors).password,
            onFocusout: _cache[5] || (_cache[5] = () => (_unref(passwordMeta).touched = true))
          }, null, 8, ["modelValue", "isError"]),
          (_unref(passwordMeta).touched && _unref(errors).password)
            ? (_openBlock(), _createBlock(ErrorMessage, {
                key: 0,
                errors: _unref(passwordErrors)
              }, null, 8, ["errors"]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_17
      ]),
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(BaseButton, {
            onClick: transitionPreviousPage,
            theme: "tertiary",
            type: "button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("戻る")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(BaseButton, {
            onClick: submit,
            theme: "primary",
            type: "button",
            disabled: _unref(meta).valid ? false : true
          }, {
            default: _withCtx(() => [
              _createTextVNode("同意して次へ")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ])
  ]))
}
}

})